export default __webpack_public_path__ + "static/media/Gregg.c668f6d0.svg";